import React, {useState, useEffect} from "react"

import { graphql } from "gatsby"

import Link from "../components/Link";
import Layout from "../components/Layout";
import Seo from "../components/Seo";
import RightContainer from "../components/RightContainer";

import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

import Container from "@material-ui/core/Container";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import ListItemText from "@material-ui/core/ListItemText";
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Hidden from '@material-ui/core/Hidden';
import {MenuContext, StyledBox, StyledPrevNextLink, PostDate, PostTitle, PostContent} from '../components/PostUtils.js';
import MUIDrawer from "../components/Drawer";

import { ThemeProvider } from 'styled-components'
import theme from "../theme.js";


export const pageQuery = graphql`
  query($slug: String!) {
    markdownRemark(frontmatter: { slug: { eq: $slug }, ispublished: { ne: false } }) {
      html
      excerpt(pruneLength: 160)
      frontmatter {
        date(formatString: "MMMM DD, YYYY")
        slug
        title
        ispage
        ispublished
        tags
        description
      }
    }
  }
`;

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    //padding: theme.spacing(1),
    display: "flex",
    justifyContent: "center",
  },
  container: {
    flexGrow: 1,
  },
  grid: {
    height: "100vh",
  },

  topgrid: {
    marginTop: "10px",
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const ContentDiv = styled.div`
  flex: 1;
  max-width: 700px;
  
  ${props => props.theme.breakpoints.down("xs")} {
    max-width: 100%;
    width: 100%;
  }
`;

const ContainerDiv = styled.div`
  flex-grow: 1;
  padding-left: 35px;
  padding-right: 35px;
  min-height: 100vh;
  background: #FAF9F7;

  ${props => props.theme.breakpoints.between("sm", "xl")} {
    padding-left: 40px;
    padding-right: 40px;
  }

  ${props => props.theme.breakpoints.up("xl")} {
    max-width: 1200px;
    margin: 0 auto;
  }

  ${props => props.theme.breakpoints.down("xs")} {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 1.7em;
  }

`;

const PostContainer = styled.div`
  margin-right: auto;
  margin-left: auto;
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 4rem;
  max-width: 1000px;
  width: 100%;
  padding: 0;

  ${props => props.theme.breakpoints.down("xs")} {
    margin-top: 1rem;
    margin-right: 0;
    margin-left: 0;
    padding: 0;
    min-height: auto;
    min-width: auto;
  }
`;


export default function Template({
  data, // this prop will be injected by the GraphQL query below.
  pageContext
}) {

  const classes = useStyles();

  const { markdownRemark } = data // data.markdownRemark holds your post data
  const { frontmatter, html, excerpt } = markdownRemark

  const next = pageContext.next ? {
    url: `${pageContext.next.frontmatter.slug}`,
    title: pageContext.next.frontmatter.title
  } : null;
  const prev = pageContext.previous ? {
    url: `${pageContext.previous.frontmatter.slug}`,
    title: pageContext.previous.frontmatter.title
  } : null;

  // Keep the burger menu closed when it first starts
  const [isOpen, setIsOpen] = useState(false);

  
  return (
    <Layout>
      <MenuContext.Provider value={{isOpen: isOpen, setIsOpen: setIsOpen}}>
        <Hidden smUp>
          <MUIDrawer/>
        </Hidden>
        <Seo
          title={frontmatter.title}
          description={frontmatter.description || excerpt}
    /*image={post.frontmatter.image.childImageSharp.sizes.src}*/
          pathname={frontmatter.slug}
          article
        />
        <ThemeProvider theme={theme}>
          <ContainerDiv>
            <PostContainer>
              <Hidden smUp>
                <RightContainer/>
              </Hidden>
              
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: '3rem', width: '100%' }}>
                <ContentDiv>
                  <PostDate>{frontmatter.date}</PostDate>
                  <PostTitle>{frontmatter.title}</PostTitle>
                  <PostContent
                    dangerouslySetInnerHTML={{ __html: html }}>
                  </PostContent>
                  {!frontmatter.ispage && (
                    <StyledBox>
                      {!next && (
                        <StyledPrevNextLink>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            flexDirection: 'row',
                          }}>
                            <span></span>
                          </div>
                        </StyledPrevNextLink>
                      )}
                      
                      {next && (
                        <StyledPrevNextLink to={next.url}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            flexDirection: 'row',
                            
                          }}>
                            <ChevronLeftIcon/>
                              <span>Previous post</span>
                          </div>
                        </StyledPrevNextLink>
                      )}
                      {prev && (
                        <StyledPrevNextLink to={prev.url}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            flexDirection: 'row',
                            
                          }}>
                              <span>Next post</span>
                            <ChevronRightIcon/>
                          </div>
                        </StyledPrevNextLink>
                      )}
                      
                    </StyledBox>
                  )}
                </ContentDiv>
                
                <Hidden xsDown>
                  <div style={{ flexShrink: 0, width: '200px' }}>
                    <RightContainer/>
                  </div>
                </Hidden>
              </div>
            </PostContainer>
          </ContainerDiv>
        </ThemeProvider>
      </MenuContext.Provider>   
    </Layout>
  );
};
